$(document).ready(function () {
    let mediaMax_sm = window.matchMedia('(max-width: 767px)')

    if ($('.swipe-mobile').length) {
        // Add slider if sm
        if (mediaMax_sm.matches) {
            $('.swipe-mobile').each(function () {
                $(this).slick({
                    dots: false,
                    arrows: false,
                    infinite: false,
                    centerMode: false,
                    slidesToShow: 1,
                    slidesToScroll: 1
                });
            });
        }
        // Add/refresh/remove slider on orientation change
        $( window ).on( "orientationchange", function( event ) {

            // time out to prevent  use of previous chage width
            setTimeout ( function () {
                // innerWidth prevent use of previous chage screen width
                let mediaMaxInner_sm = window.innerWidth < 768
    
                if (mediaMaxInner_sm) {
                    // add slider when not initialized
                    $('.swipe-mobile:not(.slick-initialized)').slick({
                        dots: false,
                        arrows: false,
                        infinite: false,
                        centerMode: false,
                        slidesToShow: 1,
                        slidesToScroll: 1
                    });
                    // refresh slider when not initialized
                    $('.swipe-mobile.slick-initialized').slick('refresh');
                } else {
                    // remove slider
                    $('.swipe-mobile.slick-initialized').slick('unslick')
                }
            }
            ,200)
        });
      }
});